import React from 'react';
import { NavLink } from 'react-router-dom';
import styles from './Sidebar.module.scss';

const Sidebar = ({ menuData, isOpen, onClose }) => {
  const generateMenuItems = (data) => {
    if (!data || !data.list || !data.list.contentItems) {
      return [];
    }

    let menuItems = [];
    data.list.contentItems.forEach(item => {
      menuItems.push({ type: 'category', name: item.displayText });
      if (item.list && item.list.contentItems) {
        item.list.contentItems.forEach(subItem => {
          const to = `/guides/${subItem.displayText.toLowerCase().replace(/[^a-z0-9]+/g, '-')}`;
          menuItems.push({
            type: 'link',
            name: subItem.displayText,
            to: to,
            iconClass: subItem.class,
          });
        });
      }
    });
    return menuItems;
  };

  const menuItems = generateMenuItems(menuData);

  return (
    <aside className={`${styles.sidebar} ${isOpen ? styles.open : ''}`}>
      <div className={styles.sidebarHeader}>
        <button onClick={onClose} className={styles.closeButton}>
          <i className="material-icons">close</i>
        </button>
      </div>
      <nav>
        <ul>
          {menuItems.map((item, index) => {
            if (item.type === 'category') {
              return <li key={index} className={styles.category}>{item.name}</li>;
            }
            return (
              <li key={index}>
                <NavLink to={item.to} onClick={onClose} className={({ isActive }) => (isActive ? styles.active : '')}>
                  <i className="material-icons">{item.iconClass || 'article'}</i>
                  <span>{item.name}</span>
                </NavLink>
              </li>
            );
          })}
        </ul>
      </nav>
    </aside>
  );
};

export default Sidebar;